import { useEffect, useState } from 'react'
import { useCMSContext } from './CMSContext'
import CMSActions from './CMSActions'
import { IarMemberEnum, UserTypeEnum } from 'app/Constants/iarMemberEnum'
import serviceBase from 'app/Services/serviceBase'

const CMShook = () => {
  const { state, actions } = useCMSContext()
  const { fireDepartment } = state
  const [isFireDepartmentLoading, setFireDepartmentLoadingFlag] = useState(false)

  useEffect(() => {
    ;(async function () {
      if (!fireDepartment && isFireDepartmentLoading === false) {
        setFireDepartmentLoadingFlag(true)
        const result = await CMSActions.getFireDepartment()
        if (result) {
          //status 5 and 6 redirect to page
          if (
            result.status === 5 ||
            result.status === 6 ||
            result.status === 2 ||
            result.status === 4 ||
            result.status === 16 //complementary suspended
          ) {
            await serviceBase.delete(`${window._env_.COMMUNITY_API_URL}/auth`)
            window.location.replace(window._env_.LOGOUT_URL || window._env_.REACT_APP_SUSPENDED_URL)
          }
          if (
            result.mylsStatus === 5 ||
            result.mylsStatus === 6 ||
            result.mylsStatus === 2 ||
            result.mylsStatus === 4
          )
            window.location.replace(window._env_.REACT_APP_SALES_DESCRIPTION)

          if (result.isCommunityAppEnabled) actions.setFireDepartment(result)
          else window.location.replace(window._env_.REACT_APP_SALES_DESCRIPTION)
        } else {
          await serviceBase.delete(`${window._env_.COMMUNITY_API_URL}/auth`)
          window.location.replace(window._env_.LOGOUT_URL || window._env_.REACT_APP_SUSPENDED_URL)
        }
      }
    })()
  }, [actions, fireDepartment, isFireDepartmentLoading])

  return null
}

const CMShookIarMember = () => {
  const { state, actions } = useCMSContext()
  const { setDisableCMSOptions, setIarMember, setIsReadOnlyMember, setIsMcsEnabled } = actions
  const { iarMember } = state

  useEffect(() => {
    ;(async function () {
      if (!iarMember) {
        await CMSActions.deleteMemberImpersonationSession()
        const result = await CMSActions.getIarMember()
        if (result === '') {
          window.location.replace(window._env_.LOGOUT_URL || window._env_.REACT_APP_SUSPENDED_URL)
        } else {
          objectPropertyComparisonByParam(
            result,
            IarMemberEnum.userType,
            UserTypeEnum.Administrator
          )(setIsReadOnlyMember)
          objectPropertyComparisonByParam(
            result,
            IarMemberEnum.isMarketingCustomSectionEnabled,
            true
          )(setIsMcsEnabled)

          if (result?.isCommunityAppEnabled) {
            setDisableCMSOptions(false)
            setIarMember(result)
            sessionStorage.setItem('browserUser', result.memberId)
          } else if (!result?.isCommunityAppEnabled && result?.isCommunityAppAlert) {
            setDisableCMSOptions(true)
            setIarMember(result)
            sessionStorage.setItem('browserUser', result.memberId)
          } else {
            window.location.replace(window._env_.REACT_APP_SALES_DESCRIPTION)
          }
        }
      } else {
        objectPropertyComparisonByParam(
          iarMember,
          IarMemberEnum.userType,
          UserTypeEnum.Administrator
        )(setIsReadOnlyMember)
        objectPropertyComparisonByParam(
          iarMember,
          IarMemberEnum.isMarketingCustomSectionEnabled,
          true
        )(setIsMcsEnabled)
        if (iarMember.isCommunityAppEnabled) {
          setDisableCMSOptions(false)
        } else if (!iarMember.isCommunityAppEnabled && iarMember.isCommunityAppAlert) {
          setDisableCMSOptions(true)
        } else {
          window.location.replace(window._env_.REACT_APP_SALES_DESCRIPTION)
        }
      }
    })()
  }, [iarMember])

  return null
}

const objectPropertyComparisonByParam = (object, param, finder) => {
  return (setter) => {
    object?.[param] === finder ? setter(true) : setter(false)
  }
}

const CMSHookDepartmentTimeBalance = () => {
  const { actions, state } = useCMSContext()
  const { setDepartmentTimeBalance } = actions
  const { fireDepartment, departmentTimeBalance } = state

  useEffect(() => {
    ;(async function () {
      if (fireDepartment && !departmentTimeBalance) {
        const result = await CMSActions.getDepartmentTimeBalanceHeader(
          fireDepartment.fireDepartmentId
        )
        if (result) {
          setDepartmentTimeBalance(result)
        }
      }
    })()
  }, [departmentTimeBalance, fireDepartment])

  return null
}

const CMSHookAppConfiguration = () => {
  const { actions, state } = useCMSContext()
  const { setAppConfiguration, setIsDemoDepartments, setNewVideoEncoding } = actions
  const { appConfiguration } = state

  useEffect(() => {
    ;(async function () {
      if (!appConfiguration) {
        const result = await CMSActions.getAppConfiguration()
        if (result) {
          setAppConfiguration(result)
          result.newVideoEncoding
            ? setNewVideoEncoding(result.newVideoEncoding)
            : setNewVideoEncoding(false)
          if (result.demoDepartments) {
            result.demoDepartments.length > 0 && setIsDemoDepartments(result.demoDepartments)
          }
        }
      }
    })()
  }, [appConfiguration, setAppConfiguration])

  return null
}

export { CMShook, CMShookIarMember, CMSHookDepartmentTimeBalance, CMSHookAppConfiguration }
